import { observable, action, makeObservable, toJS } from 'mobx';
import axios from 'axios';

class searchStore {
  search_query='';
  category=0;
  section_locating=0;
  result={ inited:false, fetching:false, data:[] };
  par=null;
  constructor(par) {
    makeObservable(this,{
      search_query:observable,
      category:observable,
      result:observable,
      section_locating:observable,
    });

    this.par=par;
  }
  getTreeObById(id) {
    for (let sectRoot in this.par.treeStore.loaded_tree) {
      if (this.par.treeStore.loaded_tree[sectRoot].data && this.par.treeStore.loaded_tree[sectRoot].data.items) {
        for (let sectInd in this.par.treeStore.loaded_tree[sectRoot].data.items) {
          if(this.par.treeStore.loaded_tree[sectRoot].data.items[sectInd].id == id) {
            return this.par.treeStore.loaded_tree[sectRoot].data.items[sectInd];
          }
        }
      }
    }
  }
  getAllRoots(item) {
    let sectionRoots = [];
    let itemSearch = item.id;
    console.log('search', itemSearch);
    while (parseInt(itemSearch) > 0) {
      const startSearch = itemSearch;
      for (let sectRoot in this.par.treeStore.loaded_tree) {
        if(this.par.treeStore.loaded_tree[sectRoot].data && this.par.treeStore.loaded_tree[sectRoot].data.items) {
          for (let sectInd in this.par.treeStore.loaded_tree[sectRoot].data.items) {
            if (this.par.treeStore.loaded_tree[sectRoot].data.items[sectInd].id == itemSearch) {
              sectionRoots.push(sectRoot);
              itemSearch = sectRoot;
              console.log('search', itemSearch);
            }
          }
        }
      }
      if (startSearch == itemSearch) {
        return false;
      }
    }
    return sectionRoots;
  }
  selectTree(item)
  {
    console.log("selectTree", toJS(item));
    const should_visible=[];
    const shouldVisibleDo=(callback)=>{
      if(should_visible.length) {
        const cur = should_visible[0];

        const tryToFind = ()=>{
          const found=this.par.treeStore.loaded_tree[cur.section].data.items.filter((item) => {
            if (item.id == cur.id) {
              return true;
            }
          });

          if(found.length) {
            should_visible.splice(0, 1);
            shouldVisibleDo(callback);
          } else {
            this.par.treeStore.loadTree(cur.section, true).then(() => {
              shouldVisibleDo(callback);
            });

          }
        }

        if (!this.par.treeStore.loaded_tree[cur.section]) {
          this.par.treeStore.loadTree(cur.section).then(() => {
            shouldVisibleDo(callback);
          });
        } else {
          tryToFind();
        }
        //this.par.treeStore.loaded_tree[cur.section].items
      } else {
        callback();
      }

    };

    if(typeof item.section === 'undefined') {
      const ob=this.getTreeObById(item.id);
      if(ob) {
        item.section=ob.section;
      }
    }

    if(!item.section && item.section!==0) {
      // axios.get(`/sysapi/dynamic/${this.category}/sections?filter[id]=${item.id}`).then((data) => {
      axios.get(`${this.par.routes.data}?filter[id]=${item.id}`).then((data) => {
        if(data.data.answer) {
          this.selectTree(data.data.answer.items[0]);
        }
      });
      return false;
    }

    if (this.par.treeStore.loaded_tree[item.section] && this.par.treeStore.loaded_tree[item.section].data) {
      const found = this.par.treeStore.loaded_tree[item.section].data.items.filter((treeItem) => {
        if (treeItem.id == item.id) {
          return true;
        }
      });
      if(found.length) {
        const allRoots=this.getAllRoots(item);
        if(allRoots) {
          for(let ind in allRoots) {
            this.par.treeStore.opened_sections[allRoots[ind]]=1;
          }
          this.par.treeStore.selected_section=item.id;
          this.search('');
          this.scrollToSelected();
          return true;
        }
      }
    }

    //WHERE left_key <= $left_key AND right_key >= $right_key ORDER BY left_key
    const leftKey=encodeURIComponent('filter[<=left_key]');
    const rightKey=encodeURIComponent('filter[>=right_key]');
    // axios.get(`/sysapi/dynamic/${this.category}/sections?${leftKey}=${item.left_key}&${rightKey}=${item.right_key}`).then((data) => {
    axios.get(`${this.par.routes.data}?${leftKey}=${item.left_key}&${rightKey}=${item.right_key}`).then((data) => {
      if(data.data.answer) {
        const openedSections={};

        for(let i in data.data.answer.items) {
          should_visible.push({section:data.data.answer.items[i].section, id:data.data.answer.items[i].id});
          openedSections[data.data.answer.items[i].id]=1;
        }
        this.section_locating=true;
        shouldVisibleDo(()=>{
          this.par.treeStore.selected_section=item.id;
          this.par.treeStore.opened_sections=openedSections;
          this.search('');
          this.section_locating=false;
          this.scrollToSelected();
        });


      }
    });
  }
  getSelectedDom() {
    if(this.par.root_element) {
      const selectedElem=this.par.root_element.querySelector('.treeSection.selected');
    }
    return false;
  }
  scrollToSelected() {
    setTimeout(()=> {
      if (this.par.root_element) {
        const selectedElem = this.par.root_element.querySelector('.treeSection.selected');
        if (!selectedElem || selectedElem.clientWidth == 0) {
          setTimeout(() => {
            this.par.root_element.querySelector('.treeSection.selected').scrollIntoView({block: "center"});
          }, 300)
        } else {
          selectedElem.scrollIntoView({block: "center"});
        }

      }
    },300);

  }

  search(str)
  {
    this.search_query=str;
    if(this.search_query) {
      const realSearch=encodeURIComponent('%'+str.replace(/\ /gi, "%")+'%');
      this.result.fetching = true;
      // axios.get(`/sysapi/dynamic/${this.category}/sections?filter[~name]=${realSearch}`).then((data) => {

      axios.get(`${this.par.routes.data}?filter[~${this.par.name_field}]=${realSearch}`).then((data) => {
        if (data.data.answer) {
          this.result.data = data.data.answer.items;
          this.result.inited = true;
        } else {
          this.result.data = [];
          this.result.inited = true;
        }
        this.result.fetching = false;
      });
    } else {
      this.result={ inited:false, fetching:false, data:[] };
    }
  }


}

/*decorate(searchStore,{
  search_query:observable,
  category:observable,
  result:observable,
  section_locating:observable,
});*/

export default searchStore;
